module.exports = __webpack_public_path__ + "static/media/construccion.92bbf173.jpg";